import * as React from 'react';

import {AiHomepageHeader} from 'shells/ai-homepage/text/ai-homepage-header';
import {Stack} from 'shells/layout/stack/stack';

import type {AiFeaturePeriod} from 'nutshell-graphql-types';

import {FeatureGrid} from './feature-grid';
import {getAiFeatureGroupingName} from './helpers';
import type {AiFeature, AiFeatureGrouping} from './types';

type Props = {
    grouping: AiFeatureGrouping;
    features: AiFeature[];
    selectedUsageTab: AiFeaturePeriod;
};

export function FeatureSubsection(props: Props) {
    const groupingName = getAiFeatureGroupingName(props.grouping);

    return (
        <Stack spacing={16}>
            <AiHomepageHeader text={groupingName} />
            <FeatureGrid features={props.features} selectedUsageTab={props.selectedUsageTab} />
        </Stack>
    );
}
